import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articlesView_template} from "../components/templates/articlesView_template";

declare var ko: any;
declare var page: any;

export class articles_view extends vnModule_knockoutJS{

    protected articlesView: articlesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "articles_view";
    }

    buildContent(): Array<Element>{

        this.articlesView = new articlesView_template("view_template", this.viewModel, this);
        return [this.articlesView.build()];
    }

    public fillPage(): void{

        this.maximizeSideNav();
        this.getArticleReferences();
        this.getArticleData();

    }

    protected maximizeSideNav(){
        document.getElementsByClassName('btn-sidebar')[0].classList.remove("is-closed");
        document.getElementsByClassName('sidenav')[0].classList.remove("is-closed");
        document.getElementsByClassName('sidenav')[0].classList.remove("is-desable");
        document.getElementsByClassName('main-header')[0].classList.remove("is-desable");
        document.getElementById('closedHeader').classList.remove("is-closed");
        document.getElementById('header').classList.remove("is-closed");
        document.getElementById('closedContent').classList.remove("is-closed");
    }

    protected getArticleReferences(){

        // LOADING : starts
        this.loadingIn(this.articlesView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferenceRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesView.setPermissions(responseParsed.permissions);
                let vnApp = obj.getVnAppZone().app;
                obj.articlesView.setIdLoggedUser(vnApp.loggedUser.user.id);

            });


            //obj.loadingOut(obj.articlesView.builtTemplate);
        }
    }


    protected getArticleData(){

        // LOADING : starts
        this.loadingIn(this.articlesView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/get/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setArticleData(responseParsed.data.article);

            });

            obj.loadingOut(obj.articlesView.builtTemplate);
        }
    }

    public setArticleData(article_data: Array<{}>): void{

        this.articlesView.setId(article_data['id']);
        this.articlesView.setTitle(article_data['title']);
        this.articlesView.setReference(article_data['reference']);
        this.articlesView.setEditor(
            article_data['editor'] ? article_data['editor']['valnet_user']['fullName'] : ""
        );
        this.articlesView.setDatePublished(article_data['dateOriginalPublish']);
        this.articlesView.setAuthor(
            article_data['author'] ? article_data['author']['valnet_user']['fullName'] : ""
        );
        this.articlesView.setAuthorId(
            article_data['author'] ? article_data['author']['id'] : ""
        );
        this.articlesView.setJrEditor(
            article_data['juniorEditor'] ? article_data['juniorEditor']['valnet_user']['fullName'] : ""
        );
        this.articlesView.setDisplayAuthor(
            article_data['displayAuthor'] ? article_data['displayAuthor']['valnet_user']['fullName'] : ""
        );
        this.articlesView.setTargetAudience(
            article_data['targetAudience'] ? article_data['targetAudience']['name'] : ""
        );
        this.articlesView.setIntent(
            article_data['intent'] ? article_data['intent']['name'] : ""
        );
        this.articlesView.setContentType(
            article_data['contentType'] ? article_data['contentType']['name'] : ""
        );
        this.articlesView.setNetworkCategory(
            article_data['networkCategory'] ? article_data['networkCategory']['name'] : ""
        );
        this.articlesView.setPostPaymentCategory(
            article_data['postPaymentCategory'] ? article_data['postPaymentCategory']['name'] : ""
        );
        this.articlesView.setArticleRepublishData(article_data['republishes']);
        this.articlesView.setPermalink(article_data['permalink']);
        this.articlesView.setPublishStatus(article_data['publishStatus']['name']);

        this.articlesView.setAmazonsiteArticleTitle(article_data['amazonsiteArticleTitle']);
        this.articlesView.setAmazonsitePublishDate(article_data['amazonsitePublishDate']);
    }

    protected editArticle(id){

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/edit-old/' + id)
    }

    protected goBackToViewArticle(){

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/');
    }
}


// WEBPACK FOOTER //
// ./js/modules/articles_view.ts